import { Config } from "@config/config";
import ISelect from "@components/forms/ISelect";
import AISelect from "@components/forms/AISelect";
import { useTranslation } from "react-i18next";
import DateInput from "@components/forms/DateInput";
import React, { useState } from "react";
import { getRoute } from "@services/axios";
const FormSearch = (props) => {
  const { t } = useTranslation();

  const config = new Config(t);
  var col = 3;
  if (props?.col) {
    col = props?.col;
  }

  const onChangeDate = (from, to) => {
    props.setDateFrom(from);
    props.setDateTo(to);
  };

  return (
    <>
      <div className="row align-items-end">
        {!props?.productOnly && (
          <>
            <div className="col-md-3 mb-3 ps-0">
              <AISelect
                selectedValue={props.selectedCountryCode}
                setSelectedValue={props.setSelectedCountryCode}
                label={t("country")}
                route={getRoute("COUNTRIES")}
                height={50}
              />
            </div>
            <div className="col-md-3 mb-3">
              <AISelect
                selectedValue={props.selectProduct}
                setSelectedValue={props.setSelectProduct}
                label={t("product")}
                route={getRoute("AUTOCOMPLETE_PRODUCTS")}
                height={50}
              />
            </div>
            <div className="col-md-3 mb-3">
              <ISelect
                id="serviceType"
                name="service_type"
                label={t("service")}
                value={props.selectedService}
                handleChange={props.setSelectedService}
                data={config.serviceOptions()}
              />
            </div>
          </>
        )}

        <div className={`col-md-${col} mb-3`}>
          <ISelect
            id="status"
            name="status"
            label={t("status")}
            value={props.selectedStatus}
            handleChange={props.setSelectedStatus}
            data={config.statusOptions()}
          />
        </div>

        <div className={`col-md-${col} mb-3 ps-0`}>
          <ISelect
            id="paymentStatus"
            name="payment_type"
            label={t("payment_status")}
            value={props.selectedPayment}
            handleChange={props.setSelectedPayment}
            data={config.paymentOptions()}
          />
        </div>

        <div className="col-md-3 mb-3">
          <DateInput
            leftLabel={t("from")}
            rightLabel={t("to")}
            onDateChange={onChangeDate}
            dateFrom={props.dateFrom}
            dateTo={props.dateTo}
          />
        </div>

        <div className={`col-md-${col} mb-3`}>
          <ISelect
            id="dateType"
            name="dateType"
            label={t("dateType")}
            value={props.selectedDate}
            handleChange={props.setSelectedDate}
            data={config.datesOptions()}
          />
        </div>
        <div className="col-md-3 mb-3">
          <button
           
            className="w-100 btn-custom"
            onClick={() => props.loadData(1)}
            style={{height:"50px"}}
          >
            {t("search")}
          </button>
        </div>
      </div>
    </>
  );
};

export default FormSearch;
